import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DeleteFileIcon from '../graphics/deleteFileIcon'
import { Fragment } from 'react'

const DoxExplorerFilesTableCountCell = (props) => {

    const handleCheckboxChange = (event) => {
        if (event.target.checked) {
            props.onFileIdSelected(props.fileId);
        }
        else {
            props.onFileIdRemoved(props.fileId);
        }
    };

    return (
        <Fragment>
            <div className={classnames('doxe-files-table-cell hrb-column size count', `hrb-is-${props.width}`)}
                style={{ justifyContent: props.justifyContent }}>
                {props.isSoftDeleted ?
                    <div className={classnames('trash-can', { 'error': props.errorKey })}>
                        <DeleteFileIcon />
                    </div>
                    :
                    props.bulkDownloadEligibility ?
                        <input className='fileSelectorCheckbox' type='checkbox' id={props.fileCounter} onChange={handleCheckboxChange} checked={props.isSelected} />
                        : <div className={classnames('trash-can', { 'error': props.errorKey })}></div>
                }
                <span>{props.fileCounter}</span>
            </div>
        </Fragment>
    )
}

DoxExplorerFilesTableCountCell.propTypes = {
    fileCounter: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    justifyContent: PropTypes.string
}

export default DoxExplorerFilesTableCountCell;